export default {
  // 字符串转base64
  encodeToBase64 (str) {
    // 兼容了只使用btoa方法不支持中文的问题
    const encoder = new TextEncoder()
    const buffer = encoder.encode(str)
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
  }
}
